import { createAsyncMutation } from '@/utils/async';

// DMP mutations
export const EXPAND_SETTINGS_ITEM = 'EXPAND_SETTINGS_ITEM';
export const GET_ACTION_PLANS = createAsyncMutation('GET_ACTION_PLANS');
export const GET_ONGOING_SECURING_ACTIONS = createAsyncMutation('GET_ONGOING_SECURING_ACTIONS');
export const GET_ONGOING_QUICK_ACTIONS = createAsyncMutation('GET_ONGOING_QUICK_ACTIONS');
export const GET_LIBRARY_INDICATORS = createAsyncMutation('GET_LIBRARY_INDICATORS');
export const GET_INDICATOR_DISPLAY_CONFIGS = createAsyncMutation('GET_INDICATOR_DISPLAY_CONFIGS');
export const GET_INDICATOR_THEMES = createAsyncMutation('GET_INDICATOR_THEMES');
export const GET_INFOS = createAsyncMutation('GET_INFOS');
export const GET_MANAGED_ACTION_PLANS = createAsyncMutation('GET_MANAGED_ACTION_PLANS');
export const GET_MANAGED_INDICATORS = createAsyncMutation('GET_MANAGED_INDICATORS');
export const GET_ROLES = createAsyncMutation('GET_ROLES');
export const GET_TEAMS = createAsyncMutation('GET_TEAMS');
export const GET_MANAGED_TEAMS = createAsyncMutation('GET_MANAGED_TEAMS');
export const GET_USERS = createAsyncMutation('GET_USERS');
export const GET_PB_TYPES = createAsyncMutation('GET_PB_TYPES');
export const GET_KEYWORDS = createAsyncMutation('GET_KEYWORDS');
export const GET_ZONES = createAsyncMutation('GET_ZONES');
export const GET_SCREEN_SAVER = createAsyncMutation('GET_SCREEN_SAVER');
export const GET_NEXT_MEETINGS = createAsyncMutation('GET_NEXT_MEETINGS');
export const GET_STICKERS = createAsyncMutation('GET_STICKERS');
export const GET_ANNOUNCEMENTS = createAsyncMutation('GET_ANNOUNCEMENTS');
export const GET_LOGO = createAsyncMutation('GET_LOGO');
export const GET_ACTION_POSTPMT_REASONS = createAsyncMutation('GET_ACTION_POSTPMT_REASONS');
export const GET_NOTIFICATION_SETTINGS = createAsyncMutation('GET_NOTIFICATION_SETTINGS');
export const GET_PENDING_ACTIONS_NUMBER = createAsyncMutation('GET_PENDING_ACTIONS_NUMBER');
export const SET_ATTEMPTING_LOGIN = 'SET_ATTEMPTING_LOGIN';
export const SET_CURRENT_JWT = 'SET_CURRENT_JWT';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_CURRENT_USER_PARAM = 'SET_CURRENT_USER_PARAM';
export const SET_CURRENT_TEAM = 'SET_CURRENT_TEAM';
export const SET_CURRENT_TEAM_PARAM = 'SET_CURRENT_TEAM_PARAM';
export const SET_INDICATOR = 'SET_INDICATOR';
export const SET_INDICATOR_VALUE = 'SET_INDICATOR_VALUE';
export const SET_INDICATOR_ANALYSIS_MSG = 'SET_INDICATOR_ANALYSIS_MSG';
export const DELETE_INDICATOR_VALUE = 'DELETE_INDICATOR_VALUE';
export const SET_CUMULATED_INDICATORS = 'SET_CUMULATED_INDICATORS';
export const SET_INDICATOR_WARNINGS = 'SET_INDICATOR_WARNINGS';
export const SET_TEAM_THEMES = 'SET_TEAM_THEMES';
export const SET_INDICATORS_ARRAY = 'SET_INDICATORS_ARRAY';
export const SET_INDICATORS_ARRAY_LOADING = 'SET_INDICATORS_ARRAY_LOADING';
export const SET_ACTIVE_ROUTE_CLICKED = 'SET_ACTIVE_ROUTE_CLICKED';
export const SET_ACTIVE_ROUTE_MATCHED = 'SET_ACTIVE_ROUTE_MATCHED';
export const SET_USER_DATA = 'SET_USER_DATA';
export const SET_USER_DATA_LODAING = 'SET_USER_DATA_LODAING';
export const SET_USER_PICTURE = 'SET_USER_PICTURE';
export const SET_USER_PICTURE_LOADING = 'SET_USER_PICTURE_LOADING';
export const SET_INFO_DATA_LOADING = 'SET_INFO_DATA_LOADING';
export const SET_INFO_DATA = 'SET_INFO_DATA';
export const HIDE_ANNOUNCEMENT = 'HIDE_ANNOUNCEMENT';
export const INIT_HIDDEN_ANNOUNCEMENTS = 'INIT_HIDDEN_ANNOUNCEMENTS';
export const SHOW_ALL_ANNOUNCEMENTS = 'SHOW_ALL_ANNOUNCEMENTS';
export const SET_HIDE_RELEASE_ESSENTIAL = 'SET_HIDE_RELEASE_ESSENTIAL';
export const SET_HIDE_ALL_RELEASE_ESSENTIAL = 'SET_HIDE_ALL_RELEASE_ESSENTIAL';
export const HIDE_DATA_USAGE = 'HIDE_DATA_USAGE';
export const INCREASE_EDITION_MODAL_INDEX = 'INCREASE_EDITION_MODAL_INDEX';
export const RESET_EDITION_MODAL_INDEX = 'RESET_EDITION_MODAL_INDEX';


// Cfg pages related mutations
export const GET_MENU_CFG_PAGES = createAsyncMutation('GET_MENU_CFG_PAGES');
export const GET_CFG_PAGES = createAsyncMutation('GET_CFG_PAGES');
export const SET_CFG_PAGE = 'SET_CFG_PAGE';
export const SET_CFG_PAGE_WIDGET = 'SET_CFG_PAGE_WIDGET';
export const SET_TEXT_PER_DATE_WIDGET = 'SET_TEXT_PER_DATE_WIDGET';


// GW related mutations
export const GET_NEXT_GWS = createAsyncMutation('GET_NEXT_GWS');
export const GET_GW_CL_ITEM_TEMPLATES = createAsyncMutation('GET_GW_CL_ITEM_TEMPLATES');
export const SET_GW_OVERLAY_VISIBILITY = 'SET_GW_OVERLAY_VISIBILITY';
export const SET_GW_OVERLAY_LAST_DATE = 'SET_GW_OVERLAY_LAST_DATE';


export default {
  EXPAND_SETTINGS_ITEM,
  GET_ACTION_PLANS,
  GET_ONGOING_SECURING_ACTIONS,
  GET_ONGOING_QUICK_ACTIONS,
  GET_LIBRARY_INDICATORS,
  GET_INDICATOR_DISPLAY_CONFIGS,
  GET_INDICATOR_THEMES,
  GET_INFOS,
  GET_MANAGED_ACTION_PLANS,
  GET_MANAGED_INDICATORS,
  GET_ROLES,
  GET_TEAMS,
  GET_MANAGED_TEAMS,
  GET_USERS,
  GET_PB_TYPES,
  GET_KEYWORDS,
  GET_ZONES,
  GET_SCREEN_SAVER,
  GET_NEXT_MEETINGS,
  GET_STICKERS,
  GET_ANNOUNCEMENTS,
  GET_LOGO,
  GET_ACTION_POSTPMT_REASONS,
  GET_NOTIFICATION_SETTINGS,
  SET_ATTEMPTING_LOGIN,
  SET_CURRENT_JWT,
  SET_CURRENT_USER,
  SET_CURRENT_USER_PARAM,
  SET_CURRENT_TEAM,
  SET_CURRENT_TEAM_PARAM,
  GET_PENDING_ACTIONS_NUMBER,
  SET_INDICATOR,
  SET_INDICATOR_VALUE,
  SET_INDICATOR_ANALYSIS_MSG,
  DELETE_INDICATOR_VALUE,
  SET_CUMULATED_INDICATORS,
  SET_INDICATOR_WARNINGS,
  SET_TEAM_THEMES,
  SET_INDICATORS_ARRAY,
  SET_INDICATORS_ARRAY_LOADING,
  SET_ACTIVE_ROUTE_CLICKED,
  SET_ACTIVE_ROUTE_MATCHED,
  SET_USER_DATA,
  SET_USER_DATA_LODAING,
  SET_USER_PICTURE,
  SET_USER_PICTURE_LOADING,
  SET_INFO_DATA_LOADING,
  SET_INFO_DATA,
  HIDE_ANNOUNCEMENT,
  INIT_HIDDEN_ANNOUNCEMENTS,
  SHOW_ALL_ANNOUNCEMENTS,
  SET_HIDE_RELEASE_ESSENTIAL,
  SET_HIDE_ALL_RELEASE_ESSENTIAL,
  HIDE_DATA_USAGE,

  GET_MENU_CFG_PAGES,
  GET_CFG_PAGES,
  SET_CFG_PAGE,
  SET_CFG_PAGE_WIDGET,
  SET_TEXT_PER_DATE_WIDGET,

  GET_NEXT_GWS,
  GET_GW_CL_ITEM_TEMPLATES,
  SET_GW_OVERLAY_VISIBILITY,
  SET_GW_OVERLAY_LAST_DATE,
};
